import { configureStore } from '@reduxjs/toolkit';
import { chatV2ListenerMiddleware } from 'ducks/chat/chatV2Listener';

import rootReducer from 'store/reducers';
import {
  applyHydration,
  hydrateProjection,
  rollBackProjection,
} from 'store/reducers/hydration';

const combinedReducer: typeof rootReducer = (state, action) => {
  const updated = rootReducer(state, action);

  if (hydrateProjection.match(action)) {
    return applyHydration(updated, action.payload.projection);
  }

  if (rollBackProjection.match(action)) {
    return applyHydration(updated, action.payload.projection);
  }

  return updated;
};

export type RootState = ReturnType<typeof combinedReducer>;
export type RootPreloadedState = Parameters<typeof combinedReducer>[0];

export const buildStore = (preloadedState?: RootPreloadedState) => {
  return configureStore({
    preloadedState,
    devTools: {
      name: 'Agent Studio',
      trace: true,
    },
    reducer: combinedReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [
            'auth/setLogin',
            'auth/setLogout',
            'auth/setGetAuthToken',
          ],
          ignoredPaths: [
            'auth.login',
            'auth.logout',
            'auth.getAuthToken',
            'payload',
          ],
        },
      }).prepend(chatV2ListenerMiddleware.middleware),
  });
};

export const store = buildStore();

export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof buildStore>;
